
import React from 'react';
import { Link } from 'react-router-dom';
import { usePhemexLang } from '@/contexts/PhemexLangContext';
import { Button } from '@/components/ui/button';
import { ArrowRight, CreditCard } from 'lucide-react';

const CallToActionSection = () => {
  const { t } = usePhemexLang();

  return (
    <div className="py-16 px-4 bg-black relative overflow-hidden">
      {/* Gradient background effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/20 to-green-900/20 opacity-50"></div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
          {t.cta.title}
        </h2>
        <p className="text-xl text-gray-300 mb-8">
          {t.cta.subtitle}
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center gap-6 mb-6">
          <Link to="/signup?campaign=phemex">
            <Button className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-6 text-lg rounded-lg shadow-[0_0_15px_rgba(37,99,235,0.5)] flex items-center gap-2">
              {t.cta.buttonText} <ArrowRight className="ml-1" size={20} />
            </Button>
          </Link>
        </div>
        
        <div className="flex items-center justify-center text-gray-400 text-sm">
          <CreditCard size={16} className="mr-2" />
          {t.cta.noCredit}
        </div>
      </div>
    </div>
  );
};

export default CallToActionSection;
